import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card } from '../components/index'
import { fetchJokes } from '../store/action/jokeAction'
import logo from '../logo1.png'


const Jokes = () => {
    const jokes = useSelector((state) => state.jokes)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchJokes())
    }, [])

    return (
        <>
        <div className="row justify-content-center">
        <img src={logo} alt="logo" className="mt-5"></img>
        </div>
        <div className="row justify-content-center">
            
            {
                jokes.map((joke) => (
                    <Card
                    key={joke.id}
                    joke={joke}
                    />
                ))
            }
        </div>
        {/* {JSON.stringify(jokes)} */}
        </>
    )
}

export default Jokes